<template>
  <div>
    <div class="layout">
      <div class="align-between">
        <!-- <h2 class="title" style="width:auto">{{this.subjectNm}}</h2> -->

        <div class="title-select-wrap">
          <button type="button" class="title" ref="subMenuTitle" @click="eventClickSubMenu($event.target)">‘통계표’ Open API</button>
          <div ref="subMenuItem">
            <ul class="subGnb-depth03 title-menu">
              <li>
                <router-link :to="{name: 'Open API'}">‘통계표’ Open API</router-link>
              </li>
              <li>
                <router-link :to="{name: 'MDSS Open API'}">‘MDSS’ Open API</router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="layout">
      <div class="api-section">
          <div class="space-bet">
          <h3 class="tit-api">서비스 개요</h3>
          </div>
        <div class="tb-scroll">
          <table class="pur-table">
            <caption>서비스 개요</caption>
            <colgroup>
              <col style="width: 12%;">
              <col style="width: 13%;">
              <col>
            </colgroup>
            <tbody>
              <tr>
                <th rowspan="3">서비스 정보</th>
                <th>서비스명(국문)</th>
                <td class="txt-left">통계표 조회 서비스</td>
              </tr>
              <tr>
                <th>서비스명(영문)</th>
                <td class="txt-left">statisticsReferenceService</td>
              </tr>
              <tr>
                <th>서비스 설명</th>
                <td class="txt-left">문화셈터에서 제공중인 통계를 조회하는 서비스입니다.</td>
              </tr>
              <tr>
                <th rowspan="2">서비스 보안</th>
                <th>서비스 인증/권한</th>
                <td class="txt-left">서비스 Key</td>
              </tr>
              <tr>
                <th>전송 레벨 암호화</th>
                <td class="txt-left">없음</td>
              </tr>
              <tr>
                <th rowspan="2">적용 기술 수준</th>
                <th>인터페이스 표준</th>
                <td class="txt-left">REST (GET, POST, PUT, DELETE)</td>
              </tr>
              <tr>
                <th>교환 데이터 표준</th>
                <td class="txt-left">JSON</td>
              </tr>
              <tr>
                <th>서비스 URL</th>
                <th>운영환경</th>
                <td class="txt-left">http://stat.mcst.go.kr/portal/openapi/stats/{오퍼레이션명(영문)}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="api-section">
        <div class="space-bet">
          <h3 class="tit-api">오퍼레이션 목록</h3>
        </div>
        <div class="tb-scroll">
          <table class="pur-table">
            <caption>오퍼레이션 목록</caption>
            <colgroup>
              <col style="width: 12%;">
              <col>
              <col>
              <col>
              <col>
            </colgroup>
            <thead>
              <tr>
                <th>일련번호</th>
                <th>서비스명(국문)</th>
                <th>오퍼레이션명(영문)</th>
                <th>오퍼레이션명(국문)</th>
                <th>메시지명(영문)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>통계표 조회 서비스</td>
                <td>getStatsLclsfList</td>
                <td>통계대분류조회</td>
                <td>N/A</td>
              </tr>
              <tr>
                <td>2</td>
                <td>통계표 조회 서비스</td>
                <td>getStatsClsfList</td>
                <td>통계분류조회</td>
                <td>N/A</td>
              </tr>
              <tr>
                <td>3</td>
                <td>통계표 조회 서비스</td>
                <td>getStatsList</td>
                <td>통계목록조회</td>
                <td>N/A</td>
              </tr>
              <tr>
                <td>4</td>
                <td>통계표 조회 서비스</td>
                <td>getStatsInfo</td>
                <td>통계정보조회</td>
                <td>N/A</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="api-section">
        <div class="space-bet">
          <h3 class="tit-api">통계 대분류 조회 오퍼레이션 명세</h3>
        </div>
        <div class="tb-scroll">
          <table class="pur-table">
            <caption>통계 대분류 조회 오퍼레이션 명세</caption>
            <colgroup>
              <col>
              <col style="width: 18%;">
              <col style="width: 24%;">
              <col style="width: 18%;">
              <col style="width: 24%;">
            </colgroup>
            <tbody>
              <tr>
                <th rowspan="4">오퍼레이션 정보</th>
                <th>오퍼레이션 번호</th>
                <td class="txt-left">1</td>
                <th>오퍼레이션명(국문)</th>
                <td class="txt-left">통계대분류조회</td>
              </tr>
              <tr>
                <th>오퍼레이션 유형</th>
                <td class="txt-left">조회(목록)</td>
                <th>오퍼레이션명(영문)</th>
                <td class="txt-left">getStatsLclsfList</td>
              </tr>
              <tr>
                <th>오퍼레이션 설명</th>
                <td colspan="3" class="txt-left">문화셈터에서 제공중인 통계 대분류 목록을 제공한다.</td>
              </tr>
              <tr>
                <th>Call Back URL</th>
                <td colspan="3" class="txt-left">N/A</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="api-section">
        <div class="space-bet">
          <h3 class="tit-api">요청 메시지 명세</h3>
          <p class="txt-str">※ 항목구분 : 필수(1), 옵션(0), 1건 이상 복수건(1..n), 0건 또는 복수건(0..n)</p>
        </div>
        <div class="tb-scroll">
          <table class="pur-table">
            <caption>요청 메시지 명세</caption>
            <thead>
              <tr>
                <th>항목명(영문)</th>
                <th>항목명(국문)</th>
                <th>항목크기</th>
                <th>항목구분</th>
                <th>샘플데이터</th>
                <th>항목설명</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>statsType</td>
                <td>통계유형</td>
                <td>2</td>
                <td>1</td>
                <td>01</td>
                <td>
                  01:주제별통계<br>
                  02:지표통계
                </td>
              </tr>
              <tr>
                <td>ctfcnVl</td>
                <td>인증값</td>
                <td>20</td>
                <td>1</td>
                <td>AD00BC12AAAD00BC12AA</td>
                <td>Open API 이용을 통해 발급된 인증값</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="api-section">
        <div class="space-bet">
          <h3 class="tit-api">응답 메시지 명세</h3>
          <p class="txt-str">※ 항목구분 : 필수(1), 옵션(0), 1건 이상 복수건(1..n), 0건 또는 복수건(0..n)</p>
        </div>
        <div class="tb-scroll">
          <table class="pur-table">
            <caption>요청 메시지 명세</caption>
            <thead>
              <tr>
                <th>항목명(영문)</th>
                <th>항목명(국문)</th>
                <th>항목크기</th>
                <th>항목구분</th>
                <th>샘플데이터</th>
                <th>항목설명</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>statsType</td>
                <td>통계유형</td>
                <td>2</td>
                <td>1</td>
                <td>01</td>
                <td>
                  01:주제별통계<br>
                  02:지표통계
                </td>
              </tr>
              <tr>
                <td>statsClsfNo</td>
                <td>통계분류번호</td>
                <td>12</td>
                <td>1</td>
                <td>STBL-1014250</td>
                <td>통계분류Key</td>
              </tr>
              <tr>
                <td>statsClsfNm</td>
                <td>통계분류명</td>
                <td>30</td>
                <td>1</td>
                <td>문화</td>
                <td>통계분류명</td>
              </tr>
              <tr>
                <td>clsfInfo</td>
                <td>분류정보</td>
                <td>200</td>
                <td>0</td>
                <td>다양한 문화분야에 관한 신뢰성 있는 통계</td>
                <td>분류에 대한 설명</td>
              </tr>
              <tr>
                <td>clsfType</td>
                <td>분류유형</td>
                <td>4</td>
                <td>1</td>
                <td>STBL</td>
                <td>통계분류의 유형</td>
              </tr>
              <tr>
                <td>lwrClsfEn</td>
                <td>하위분류유무</td>
                <td>1</td>
                <td>1</td>
                <td>Y</td>
                <td>
                  Y:하위분류있음<br>
                  N:하위분류없음
                </td>
              </tr>
              <tr>
                <td>sortSeq</td>
                <td>정렬순서</td>
                <td>2</td>
                <td>1</td>
                <td>1</td>
                <td>정렬순서</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="api-section">
        <div class="space-bet">
          <h3 class="tit-api">요청/응답 메시지 예제</h3>
        </div>
        <div class="tb-scroll">
          <table class="pur-table">
            <caption>요청/응답 메시지 예제 - REST(URL)</caption>
            <thead>
              <tr>
                <th>REST(URL)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="txt-left">http://stat.mcst.go.kr/portal/openapi/stats/getStatsLclsfList?statsType=01&ctfcnVl=AD00BC12AAAD00BC12AA
                </td>
              </tr>
            </tbody>
          </table>
          <table class="pur-table">
            <caption>요청/응답 메시지 예제 - 응답 메시지</caption>
            <thead>
              <tr>
                <th>응답 메시지</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="txt-left">
                  <pre>
                    <code>
                      {
                        "rspnsRslt": {
                              "rspnsCd": "0",
                              "rspnsMsg": "NORMAL_SERVICE",
                              "rspnsData": [
                                    {
                                            "statsType": "01",
                                            "statsClsfNo": "STBL-1014250",
                                            "statsClsfNm": "문화",
                                            "clsfInfo": "다양한 문화분야에 관한 신뢰성 있는 통계",
                                            "clsfType": "STBL",
                                            "lwrClsfEn": "Y",
                                            "sortSeq": "1"
                                      },
                                    {
                                              "statsType": "01",
                                              "statsClsfNo": "STBL-1030638",
                                              "statsClsfNm": "예술",
                                              "clsfInfo": "다양한 예술 분야에 관한 신뢰성 있는 통계",
                                              "clsfType": "STBL",
                                              "lwrClsfEn": "Y",
                                              "sortSeq": "2"
                                      },
                                      ...
                                      ...
                                  ]
                          }
                      }
                    </code>
                  </pre>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="api-section">
        <div class="space-bet">
          <h3 class="tit-api">통계분류조회 오퍼레이션 명세</h3>
        </div>
        <div class="tb-scroll">
          <table class="pur-table">
            <caption>통계분류조회 오퍼레이션 명세</caption>
            <colgroup>
              <col>
              <col style="width: 18%;">
              <col style="width: 24%;">
              <col style="width: 18%;">
              <col style="width: 24%;">
            </colgroup>
            <tbody>
              <tr>
                <th rowspan="4">오퍼레이션 정보</th>
                <th>오퍼레이션 번호</th>
                <td class="txt-left">2</td>
                <th>오퍼레이션명(국문)</th>
                <td class="txt-left">통계분류조회</td>
              </tr>
              <tr>
                <th>오퍼레이션 유형</th>
                <td class="txt-left">조회(목록)</td>
                <th>오퍼레이션명(영문)</th>
                <td class="txt-left">getStatsClsfList</td>
              </tr>
              <tr>
                <th>오퍼레이션 설명</th>
                <td colspan="3" class="txt-left">문화셈터에서 제공중인 통계 대분류에 대한 분류 목록을 제공한다.</td>
              </tr>
              <tr>
                <th>Call Back URL</th>
                <td colspan="3" class="txt-left">N/A</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="api-section">
        <div class="space-bet">
          <h3 class="tit-api">요청 메시지 명세</h3>
          <p class="txt-str">※ 항목구분 : 필수(1), 옵션(0), 1건 이상 복수건(1..n), 0건 또는 복수건(0..n)</p>
        </div>
        <div class="tb-scroll">
          <table class="pur-table">
            <caption>요청 메시지 명세</caption>
            <thead>
              <tr>
                <th>항목명(영문)</th>
                <th>항목명(국문)</th>
                <th>항목크기</th>
                <th>항목구분</th>
                <th>샘플데이터</th>
                <th>항목설명</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>statsType</td>
                <td>통계유형</td>
                <td>2</td>
                <td>1</td>
                <td>01</td>
                <td>
                  01:주제별통계<br>
                  02:지표통계
                </td>
              </tr>
              <tr>
                <td>statsClsfNo</td>
                <td>통계분류번호</td>
                <td>12</td>
                <td>1</td>
                <td>STBL-1025445</td>
                <td>통계분류Key</td>
              </tr>
              <tr>
                <td>ctfcnVl</td>
                <td>인증값</td>
                <td>20</td>
                <td>1</td>
                <td>AD00BC12AAAD00BC12AA</td>
                <td>Open API 이용을 통해 발급된 인증값</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="api-section">
        <div class="space-bet">
          <h3 class="tit-api">응답 메시지 명세</h3>
          <p class="txt-str">※ 항목구분 : 필수(1), 옵션(0), 1건 이상 복수건(1..n), 0건 또는 복수건(0..n)</p>
        </div>
        <div class="tb-scroll">
          <table class="pur-table">
            <caption>응답 메시지 명세</caption>
            <thead>
              <tr>
                <th>항목명(영문)</th>
                <th>항목명(국문)</th>
                <th>항목크기</th>
                <th>항목구분</th>
                <th>샘플데이터</th>
                <th>항목설명</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>statsType</td>
                <td>통계유형</td>
                <td>2</td>
                <td>1</td>
                <td>01</td>
                <td>
                  01:주제별통계<br>
                  02:지표통계
                </td>
              </tr>
              <tr>
                <td>statsClsfNo</td>
                <td>통계분류번호</td>
                <td>12</td>
                <td>1</td>
                <td>STBL-1014259</td>
                <td>통계분류Key</td>
              </tr>
              <tr>
                <td>statsClsfNm</td>
                <td>통계분류명</td>
                <td>30</td>
                <td>1</td>
                <td>국민문화예술활동조사</td>
                <td>통계분류명</td>
              </tr>
              <tr>
                <td>upClsfNo</td>
                <td>상위분류번호</td>
                <td>200</td>
                <td>0</td>
                <td>다양한 문화분야에 관한 신뢰성 있는 통계</td>
                <td>분류에 대한 설명</td>
              </tr>
              <tr>
                <td>clsfType</td>
                <td>분류유형</td>
                <td>12</td>
                <td>1</td>
                <td>STBL-1014250</td>
                <td>상위분류Key</td>
              </tr>
              <tr>
                <td>clsfType</td>
                <td>분류유형</td>
                <td>4</td>
                <td>1</td>
                <td>STBL</td>
                <td>통계분류의 유형</td>
              </tr>
              <tr>
                <td>lwrClsfEn</td>
                <td>하위분류유무</td>
                <td>1</td>
                <td>1</td>
                <td>Y</td>
                <td>
                  Y:하위분류있음
                  <br>
                  N:하위분류없음
                </td>
              </tr>
              <tr>
                <td>sortSeq</td>
                <td>정렬순서</td>
                <td>2</td>
                <td>1</td>
                <td>1</td>
                <td>정렬순서</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="api-section">
        <div class="space-bet">
          <h3 class="tit-api">요청/응답 메시지 예제</h3>
        </div>
        <div class="tb-scroll">
          <table class="pur-table">
            <caption>요청/응답 메시지 예제 - REST(URL)</caption>
            <thead>
              <tr>
                <th>REST(URL)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="txt-left">http://stat.mcst.go.kr/portal/openapi/stats/getStatsClsfList?statsType=01&statsClsfNo=STBL-1014264&ctfcnVl=AD00BC12AAAD00BC12AA</td>
              </tr>
            </tbody>
          </table>
          <table class="pur-table">
            <caption>요청/응답 메시지 예제 - 응답 메시지</caption>
            <thead>
              <tr>
                <th>응답 메시지</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="txt-left">
                  <pre>
                    <code>
                      {
                        "rspnsRslt": {
                            "rspnsCd": "0",
                            "rspnsMsg": "NORMAL_SERVICE",
                            "rspnsData": [
                                {
                                    "statsType": "01",
                                    "statsClsfNo": "STBL-1012584",
                                    "statsClsfNm": "여가자원 실태",
                                    "upClsfNo": "STBL-1014264",
                                    "clsfType": "STBL",
                                    "lwrClsfEn": "N",
                                    "sortSeq": "1"
                                },
                                {
                                    "statsType": "01",
                                    "statsClsfNo": "STBL-1025490",
                                    "statsClsfNm": "2010년 이전 통계표",
                                    "upClsfNo": "STBL-1014264",
                                    "clsfType": "STBL",
                                    "lwrClsfEn": "Y",
                                    "sortSeq": "2"
                                },
                                ...
                                ...
                            ]
                        }
                    }
                    </code>
                  </pre>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="api-section">
        <div class="space-bet">
          <h3 class="tit-api">통계목록조회 오퍼레이션 명세</h3>
        </div>
        <div class="tb-scroll">
          <table class="pur-table">
            <caption>통계목록조회 오퍼레이션 명세</caption>
            <colgroup>
              <col>
              <col style="width: 18%;">
              <col style="width: 24%;">
              <col style="width: 18%;">
              <col style="width: 24%;">
            </colgroup>
            <tbody>
              <tr>
                <th rowspan="4">오퍼레이션 정보</th>
                <th>오퍼레이션 번호</th>
                <td class="txt-left">3</td>
                <th>오퍼레이션명(국문)</th>
                <td class="txt-left">통계목록조회</td>
              </tr>
              <tr>
                <th>오퍼레이션 유형</th>
                <td class="txt-left">조회(목록)</td>
                <th>오퍼레이션명(영문)</th>
                <td class="txt-left">getStatsList</td>
              </tr>
              <tr>
                <th>오퍼레이션 설명</th>
                <td colspan="3" class="txt-left">문화셈터에서 제공중인 통계 분류에 대한 통계 목록을 제공한다.</td>
              </tr>
              <tr>
                <th>Call Back URL</th>
                <td colspan="3" class="txt-left">N/A</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="api-section">
        <div class="space-bet">
          <h3 class="tit-api">요청 메시지 명세</h3>
          <p class="txt-str">※ 항목구분 : 필수(1), 옵션(0), 1건 이상 복수건(1..n), 0건 또는 복수건(0..n)</p>
        </div>
        <div class="tb-scroll">
          <table class="pur-table">
            <caption>요청 메시지 명세</caption>
            <thead>
              <tr>
                <th>항목명(영문)</th>
                <th>항목명(국문)</th>
                <th>항목크기</th>
                <th>항목구분</th>
                <th>샘플데이터</th>
                <th>항목설명</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>statsType</td>
                <td>통계유형</td>
                <td>2</td>
                <td>1</td>
                <td>01</td>
                <td>
                  01:주제별통계<br>
                  02:지표통계
                </td>
              </tr>
              <tr>
                <td>statsClsfNo</td>
                <td>통계분류번호</td>
                <td>12</td>
                <td>1</td>
                <td>STBL-1014264</td>
                <td>통계분류Key</td>
              </tr>
              <tr>
                <td>ctfcnVl</td>
                <td>인증값</td>
                <td>20</td>
                <td>1</td>
                <td>AD00BC12AAAD00BC12AA</td>
                <td>Open API 이용을 통해 발급된 인증값</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="api-section">
        <div class="space-bet">
          <h3 class="tit-api">응답 메시지 명세</h3>
          <p class="txt-str">※ 항목구분 : 필수(1), 옵션(0), 1건 이상 복수건(1..n), 0건 또는 복수건(0..n)</p>
        </div>
        <div class="tb-scroll">
          <table class="pur-table">
            <caption>요청 메시지 명세</caption>
            <thead>
              <tr>
                <th>항목명(영문)</th>
                <th>항목명(국문)</th>
                <th>항목크기</th>
                <th>항목구분</th>
                <th>샘플데이터</th>
                <th>항목설명</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>statsType</td>
                <td>통계유형</td>
                <td>2</td>
                <td>1</td>
                <td>01</td>
                <td>
                  01:주제별통계<br>
                  02:지표통계
                </td>
              </tr>
              <tr>
                <td>statsMngNo</td>
                <td>통계분류번호</td>
                <td>12</td>
                <td>1</td>
                <td>STBL-1028403</td>
                <td>통계관리Key</td>
              </tr>
              <tr>
                <td>statsNm</td>
                <td>통계분류명</td>
                <td>200</td>
                <td>1</td>
                <td>(향후 1년 동안) 가장 이용하고 싶은 여가공간 (1순위)</td>
                <td>통계명</td>
              </tr>
              <tr>
                <td>upClsfNo</td>
                <td>상위분류번호</td>
                <td>12</td>
                <td>1</td>
                <td>STBL-1014250</td>
                <td>상위분류Key</td>
              </tr>
              <tr>
                <td>sortSeq</td>
                <td>정렬순서</td>
                <td>2</td>
                <td>1</td>
                <td>1</td>
                <td>정렬순서</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="api-section">
        <div class="space-bet">
          <h3 class="tit-api">요청/응답 메시지 예제</h3>
        </div>
        <div class="tb-scroll">
          <table class="pur-table">
            <caption>요청/응답 메시지 예제 - REST(URL)</caption>
            <thead>
              <tr>
                <th>REST(URL)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="txt-left">http://stat.mcst.go.kr/portal/openapi/stats/getStatsList?statsType=01&statsClsfNo=STBL-1014264&ctfcnVl=AD00BC12AAAD00BC12AA</td>
              </tr>
            </tbody>
          </table>
          <table class="pur-table">
            <caption>요청/응답 메시지 예제 - 응답 메시지</caption>
            <thead>
              <tr>
                <th>응답 메시지</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="txt-left">
                  <pre>
                    <code>
                      {
                        "rspnsRslt": {
                            "rspnsCd": "0",
                            "rspnsMsg": "NORMAL_SERVICE",
                            "rspnsData": [
                                {
                                    "statsType": "01",
                                    "statsMngNo": "STBL-1028401",
                                    "statsNm": "지난 1년 동안 지출한 여가비용(한 달 평균)에 대한 평가",
                                    "upClsfNo": "STBL-1014264",
                                    "sortSeq": "1"
                                },
                                {
                                    "statsType": "01",
                                    "statsMngNo": "STBL-1028402",
                                    "statsNm": "적절하다고 생각하는 여가비용(한 달 평균)",
                                    "upClsfNo": "STBL-1014264",
                                    "sortSeq": "2"
                                },
                                ...
                                ...
                            ]
                        }
                    }
                    </code>
                  </pre>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="api-section">
        <div class="space-bet">
          <h3 class="tit-api">통계정보조회 오퍼레이션 명세</h3>
        </div>
        <div class="tb-scroll">
          <table class="pur-table">
            <caption>통계정보조회 오퍼레이션 명세</caption>
            <colgroup>
              <col>
              <col style="width: 18%;">
              <col style="width: 24%;">
              <col style="width: 18%;">
              <col style="width: 24%;">
            </colgroup>
            <tbody>
              <tr>
                <th rowspan="4">오퍼레이션 정보</th>
                <th>오퍼레이션 번호</th>
                <td class="txt-left">4</td>
                <th>오퍼레이션명(국문)</th>
                <td class="txt-left">통계정보조회</td>
              </tr>
              <tr>
                <th>오퍼레이션 유형</th>
                <td class="txt-left">조회(목록)</td>
                <th>오퍼레이션명(영문)</th>
                <td class="txt-left">getStatsInfo</td>
              </tr>
              <tr>
                <th>오퍼레이션 설명</th>
                <td colspan="3" class="txt-left">문화셈터에서 제공중인 통계 정보를 제공한다.</td>
              </tr>
              <tr>
                <th>Call Back URL</th>
                <td colspan="3" class="txt-left">N/A</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="api-section">
        <div class="space-bet">
          <h3 class="tit-api">요청 메시지 명세</h3>
          <p class="txt-str">※ 항목구분 : 필수(1), 옵션(0), 1건 이상 복수건(1..n), 0건 또는 복수건(0..n)</p>
        </div>
        <div class="tb-scroll">
          <table class="pur-table">
            <caption>요청 메시지 명세</caption>
            <thead>
              <tr>
                <th>항목명(영문)</th>
                <th>항목명(국문)</th>
                <th>항목크기</th>
                <th>항목구분</th>
                <th>샘플데이터</th>
                <th>항목설명</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>statsType</td>
                <td>통계유형</td>
                <td>2</td>
                <td>1</td>
                <td>01</td>
                <td>
                  01:주제별통계<br>
                  02:지표통계
                </td>
              </tr>
              <tr>
                <td>statsClsfNo</td>
                <td>통계분류번호</td>
                <td>12</td>
                <td>1</td>
                <td>STBL-1028401</td>
                <td>통계분류Key, 해당 값을 넣을 경우<br> 여러개의 통계를 받을 수 있음,<br>
                  통계관리번호와 동시에 사용 불가</td>
              </tr>
              <tr>
                <td>statsMngNo</td>
                <td>통계관리번호</td>
                <td>12</td>
                <td>1..n</td>
                <td>STBL-1028403</td>
                <td>통계관리Key, 해당 값을 넣을 경우<br> 한개의 통계를 받을 수 있음,<br>
                  통계분류번호와 동시에 사용 불가</td>
              </tr>
              <tr>
                <td>ctfcnVl</td>
                <td>인증값</td>
                <td>20</td>
                <td>1</td>
                <td>AD00BC12AAAD00BC12AA</td>
                <td>Open API 이용을 통해 발급된 인증값</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="api-section">
        <div class="space-bet">
          <h3 class="tit-api">응답 메시지 명세</h3>
          <p class="txt-str">※ 항목구분 : 필수(1), 옵션(0), 1건 이상 복수건(1..n), 0건 또는 복수건(0..n)</p>
        </div>
        <div class="tb-scroll">
          <table class="pur-table">
            <caption>요청 메시지 명세</caption>
            <thead>
              <tr>
                <th>항목명(영문)</th>
                <th>항목명(국문)</th>
                <th>항목크기</th>
                <th>항목구분</th>
                <th>샘플데이터</th>
                <th>항목설명</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>statsMngNo</td>
                <td>통계관리번호</td>
                <td>2</td>
                <td>1</td>
                <td>01</td>
                <td>
                  01:주제별통계<br>
                  02:지표통계
                </td>
              </tr>
              <tr>
                <td>statsNm</td>
                <td>통계분류명</td>
                <td>200</td>
                <td>1</td>
                <td>(향후 1년 동안) 가장 이용하고 싶은 여가공간 (1순위)</td>
                <td>통계명</td>
              </tr>
              <tr>
                <td>artcList</td>
                <td>항목목록</td>
                <td></td>
                <td>1..n</td>
                <td>[..]</td>
                <td>항목목록</td>
              </tr>
              <tr>
                <td>artcType</td>
                <td>항목유형</td>
                <td>1</td>
                <td>1</td>
                <td>01</td>
                <td>
                  01:표두<br>
                  02:표측
                </td>
              </tr>
              <tr>
                <td>artcNm</td>
                <td>항목변수명</td>
                <td>40</td>
                <td>1</td>
                <td>여가활동</td>
                <td>통계데이터의 변수명</td>
              </tr>
              <tr>
                <td>artcCd</td>
                <td>항목변수코드</td>
                <td>40</td>
                <td>1</td>
                <td>CODE-001</td>
                <td>통계데이터의 변수Key</td>
              </tr>
              <tr>
                <td>pstnSeq</td>
                <td>위치순서</td>
                <td>40</td>
                <td>0</td>
                <td>1</td>
                <td>표두나 표측의 행 또는 열의 위치 순서</td>
              </tr>
              <tr>
                <td>artcVlList</td>
                <td>항목값목록</td>
                <td></td>
                <td>1..n</td>
                <td>[..]</td>
                <td>항목의 실제 값</td>
              </tr>
              <tr>
                <td>{항목변수코드}</td>
                <td>항목변수값</td>
                <td>40</td>
                <td>1..n</td>
                <td>CODE-001</td>
                <td>
                  항목변수,<br>
                  항목에 따라 항목명(영문)이 변경 됨
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="api-section">
        <div class="space-bet">
          <h3 class="tit-api">요청/응답 메시지 예제</h3>
        </div>
        <div class="tb-scroll">
          <table class="pur-table">
            <caption>요청/응답 메시지 예제 - REST(URL)</caption>
            <thead>
              <tr>
                <th>REST(URL)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="txt-left">
                  http://stat.mcst.go.kr/portal/openapi/stats/getStatsInfo?statsType=01&statsClsfNo=STBL-1028403&ctfcnVl=AD00BC12AAAD00BC12AA<br>
                  http://stat.mcst.go.kr/portal/openapi/stats/getStatsInfo?statsType=01&statsMngNo=STBL-1028403,STBL-1028402&ctfcnVl=AD00BC12AAAD00BC12AA
                </td>
              </tr>
            </tbody>
          </table>
          <table class="pur-table">
            <caption>요청/응답 메시지 예제 - 응답 메시지</caption>
            <thead>
              <tr>
                <th>응답 메시지</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="txt-left">
                  <pre>
                    <code>
                      {
                        "rspnsRslt": {
                            "rspnsCd": "0",
                            "rspnsMsg": "NORMAL_SERVICE",
                            "rspnsData": [
                                {
                                    "statsMngNo": "STBL-1028401",
                                    "statsNm": "지난 1년 동안 지출한 여가비용(한 달 평균)에 대한 평가",
                                    "artcList": [
                                        {
                                            "artcType": "01",
                                            "artcNm": "년도",
                                            "artcCd": "CODE-001",
                                            "pstnSeq": "1"
                                        },
                                        {
                                            "artcType": "01",
                                            "artcNm": "여가활동",
                                            "artcCd": "CODE-002",
                                            "pstnSeq": "2"
                                        },
                                        {
                                            "artcType": "02",
                                            "artcNm": "구분",
                                            "artcCd": "CODE-003",
                                            "pstnSeq": "1"
                                        },
                                        {
                                            "artcType": "02",
                                            "artcNm": "상세구분",
                                            "artcCd": "CODE-004",
                                            "pstnSeq": "2"
                                        }
                                    ] ,
                                    "artcVlList": [
                                        {
                                            "CODE-001": "2023",
                                            "CODE-002": "연극공연 관람",
                                            "CODE-003": "17개 시도별",
                                            "CODE-004": "제주",
                                            "artcDataVl": "6.2"
                                        },
                                        {
                                            "CODE-001": "2023",
                                            "CODE-002": "연극공연 관람",
                                            "CODE-003": "17개 시도별",
                                            "CODE-004": "울산",
                                            "artcDataVl": "6.2"
                                        },
                                        {
                                            "CODE-001": "2023",
                                            "CODE-002": "연극공연 관람",
                                            "CODE-003": "가구소득별",
                                            "CODE-004": "300~400만원",
                                            "artcDataVl": "4.3"
                                        },
                                        {
                                            "CODE-001": "2023",
                                            "CODE-002": "연극공연 관람",
                                            "CODE-003": "가구소득별",
                                            "CODE-004": "100~200만원",
                                            "artcDataVl": "1.1"
                                        },
                                        {
                                            "CODE-001": "2021",
                                            "CODE-002": "전통예술공연 관람",
                                            "CODE-003": "가구소득별",
                                            "CODE-004": "300~400만원",
                                            "artcDataVl": "47.6"
                                        },
                                        {
                                            "CODE-001": "2021",
                                            "CODE-002": "전통예술공연 관람",
                                            "CODE-003": "가구소득별",
                                            "CODE-004": "100~200만원",
                                            "artcDataVl": "17.6"
                                        },
                                        {
                                            "CODE-001": "2021",
                                            "CODE-002": "영화관람",
                                            "CODE-003": "권역별",
                                            "CODE-004": "수도권",
                                            "artcDataVl": "47.6"
                                        },
                                        {
                                            "CODE-001": "2021",
                                            "CODE-002": "영화관람",
                                            "CODE-003": "권역별",
                                            "CODE-004": "동남권",
                                            "artcDataVl": "0.6"
                                        },
                                    ]
                                },
                                ...
                                ...
                            ],
                            ...
                            ...
                        }
                    }
                    ========================= 하위분류가 있는 통계분류를 요청했을 경우==========================
                    {
                        "rspnsRslt": {
                            "rspnsCd": "13",
                            "rspnsMsg": "LOWER_CLASSIFICATION_EXISTENCE",
                            "rspnsData": []
                      }
                    </code>
                  </pre>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="api-section">
        <div class="space-bet">
          <h3 class="tit-api">Open API 에러코드</h3>
        </div>
        <div class="tb-scroll">
          <table class="pur-table">
            <caption>Open API 에러코드</caption>
            <colgroup>
              <col style="width: 10%;">
              <col>
              <col>
            </colgroup>
            <thead>
              <tr>
                <th>에러코드</th>
                <th>에러메세지</th>
                <th>설명</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>0</td>
                <td class="txt-left">NORMAL_SERVICE</td>
                <td class="txt-left">정상</td>
              </tr>
              <tr>
                <td>1</td>
                <td class="txt-left">APPLICATION_ERROR</td>
                <td class="txt-left">어플리케이션 에러</td>
              </tr>
              <tr>
                <td>2</td>
                <td class="txt-left">DB_ERROR</td>
                <td class="txt-left">데이터베이스 에러</td>
              </tr>
              <tr>
                <td>3</td>
                <td class="txt-left">NODATA_ERROR</td>
                <td class="txt-left">데이터없음 에러</td>
              </tr>
              <tr>
                <td>4</td>
                <td class="txt-left">HTTP_ERROR</td>
                <td class="txt-left">HTTP 에러</td>
              </tr>
              <tr>
                <td>5</td>
                <td class="txt-left">SERVICETIMEOUT_ERROR</td>
                <td class="txt-left">서비스 연결실패 에러</td>
              </tr>
              <tr>
                <td>10</td>
                <td class="txt-left">INVALID_REQUEST_PARAMETER_ERROR</td>
                <td class="txt-left">잘못된 요청 파라메터 에러</td>
              </tr>
              <tr>
                <td>11</td>
                <td class="txt-left">NO_MANDATORY_REQUEST_PARAMETERS_ERROR</td>
                <td class="txt-left">필수요청 파라메터가 없음</td>
              </tr>
              <tr>
                <td>12</td>
                <td class="txt-left">NO_OPENAPI_SERVICE_ERROR</td>
                <td class="txt-left">해당 오픈API서비스가 없거나 폐기됨</td>
              </tr>
              <tr>
                <td>13</td>
                <td class="txt-left">LOWER_CLASSIFICATION_EXISTENCE</td>
                <td class="txt-left">하위 분류가 있음</td>
              </tr>
              <tr>
                <td>20</td>
                <td class="txt-left">SERVICE_ACCESS_DENIED_ERROR</td>
                <td class="txt-left">서비스 접근거부</td>
              </tr>
              <tr>
                <td>21</td>
                <td class="txt-left">TEMPORARILY_DISABLE_THE_SERVICEKEY_ERROR</td>
                <td class="txt-left">일시적으로 사용할 수 없는 서비스 키</td>
              </tr>
              <tr>
                <td>99</td>
                <td class="txt-left">UNKNOWN_ERROR</td>
                <td class="txt-left">기타에러</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  export default {
      name: 'StatsOpenApi',
      mounted() {
        const currentMenu = document.querySelector('.router-link-active').innerText
        document.querySelector('.title-select-wrap > button').textContent = currentMenu
      },
      methods: {
        eventClickSubMenu (target) {
          if (target) {
            const subMenuItemDiv = target.nextElementSibling
            if (subMenuItemDiv && subMenuItemDiv.children) {
              const subMenuItemUl = subMenuItemDiv.querySelector('.subGnb-depth03')
              if (subMenuItemUl.style.display === 'block') {
                $(subMenuItemDiv.children[0]).stop().slideUp()
              } else {
                $(subMenuItemDiv.children[0]).stop().slideDown()
              }
            }
          }
        },
      }
  }
</script>

<style scoped>

</style>
